import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Accordion, Button, Alert } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import FloatingActionButton from './FloatingActionButton'
import { useContent } from '../hooks/useContent'
import Footer from './footer'
import './OurStory.css'
import './PlanYourJourney.css'

import plan from '../assets/imgDisp/plan.jpg'
import simply from '../assets/imgDisp/simply.jpg'



const PlanYourJourney = () => {
  const navigate = useNavigate()
  const { content, loading, error } = useContent('planYourJourney')

  // Use content with fallbacks
  const heroContent = content?.hero || {
    title: 'Let Us Guide You Here',
    subtitle: 'Everything you need to plan your visit tucked deep in nature.',
    backgroundImage: '',
  }
  const howToReachContent = content?.howToReach || {
    title: 'How to Reach',
    methods: [],
  }
  const weatherPackingContent = content?.weatherPacking || {
    title: 'Weather & What to Pack',
    items: [],
    image: '',
  }
  const travelTipsContent = content?.travelTips || {
    title: 'Travel Tips & FAQs',
    faqs: [],
  }
  const locationContent = content?.locationDirections || {
    title: 'Location & Directions',
    coordinates: {},
    route: '',
    mapsButtonText: 'Open in Maps',
    mapsLink: '',
  }

  const defaultPlanHero = plan;
const defaultPackingImage = simply;

// Track hero image load to avoid overlay flash
const [heroImage, setHeroImage] = useState('')
const [heroLoaded, setHeroLoaded] = useState(false)

useEffect(() => {
  if (loading) return
  let cancelled = false
  const desired = (heroContent?.backgroundImage || defaultPlanHero || '').trim()

  const load = (src) => {
    setHeroLoaded(false)
    const img = new Image()
    img.onload = () => {
      if (cancelled) return
      setHeroImage(src)
      setHeroLoaded(true)
    }
    img.onerror = () => {
      if (cancelled) return
      if (src !== defaultPlanHero) {
        load(defaultPlanHero)
      } else {
        setHeroImage(defaultPlanHero)
        setHeroLoaded(true)
      }
    }
    img.src = src
  }

  if (desired) load(desired)
  else load(defaultPlanHero)

  return () => { cancelled = true }
}, [loading, heroContent?.backgroundImage])



  // Removed loading spinner: render page immediately with fallback content.

  // Show error state
  if (error) {
    return (
      <div className='story-page'>
        <Alert variant='danger' className='text-center mb-0'>
          <strong>Content Loading Error:</strong> {error}
          <p className='mt-2'>Please try refreshing the page.</p>
        </Alert>
      </div>
    )
  }

  return (
    <div className='plan-page'>
      {/* Hero */}
    <section className="hero-section plan-page">
  <div
    className="hero-image"
    style={{ backgroundImage: heroImage ? `url(${heroImage})` : 'none' }}
  >
    <div className={`hero-overlay ${heroLoaded ? 'is-loaded' : ''}`}>
      <div className="hero-content">
        <h1 className="hero-title">{heroContent.title}</h1>
        <p className="hero-subtitle">{heroContent.subtitle}</p>
      </div>
    </div>
  </div>
</section>



      {/* How to Reach */}
      <section className='dream-section'>
        <Container>
          <h2 className='section-head'>{howToReachContent.title}</h2>
          <Row className='text-center'>
            {howToReachContent.methods.map((method, index) => (
              <Col md={4} key={index}>
                <h5>
                  {method.icon} {method.title}
                </h5>
                <p>
                  {method.lines.map((line, idx) => (
                    <span key={idx}>
                      {line}
                      {idx < method.lines.length - 1 && <br />}
                    </span>
                  ))}
                </p>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Weather & Packing */}
      <section className='farming-section'>
        <Container>
          <h2 className='section-head text-center mb-4'>
            {weatherPackingContent.title}
          </h2>
          <Row>
            <Col md={6}>
              <ul className='impact-list'>
                {weatherPackingContent.items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </Col>
            <Col md={6}>
              <div className='story-image-container'>
                <div
                  className='story-image rounded-lg'
                  style={{
                    backgroundImage: `url('${weatherPackingContent.image || defaultPackingImage
                      }')`,
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Travel Tips & FAQs (match Stays FAQ styles) */}
      <section className='faq-section py-5 bg-light'>
        <Container>
          <h2 className='section-head'>
            {travelTipsContent.title}
          </h2>
          <Accordion defaultActiveKey='0' className='faq-accordion'>
            {travelTipsContent.faqs.map((faq, index) => (
              <Accordion.Item eventKey={String(index)} key={index}>
                <Accordion.Header>
                  <h3>{faq.question}</h3>
                </Accordion.Header>
                <Accordion.Body>
                  <p>{faq.answer}</p>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Container>
      </section>

      {/* Coordinates & Route */}
      <section className='sectionCta py-5 text-center'>
        <Container>
          <h2 className='section-head'>{locationContent.title}</h2>
          <p className='cta-text'>
            {locationContent.coordinates.latitude},{' '}
            {locationContent.coordinates.longitude}
          </p>
          <p className='cta-text'>{locationContent.route}</p>

          <div className='maps-actions'>
            <button
              className='book-btn'
              onClick={() => window.open(locationContent.mapsLink, '_blank')}
            >
              {locationContent.mapsButtonText}
            </button>
          </div>
        </Container>
      </section>

      {/* Footer */}
      <Footer />

      <FloatingActionButton />
    </div>
  )
}

export default PlanYourJourney
